import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { validateAppointment, generateWhatsAppMessage, formatPhoneForWhatsApp } from '../utils/appointmentUtils';
import { formatDateForLocal } from '../utils/dateUtils';

const AppointmentModal = ({
  open,
  onClose,
  onSave,
  appointment,
  setAppointment,
  pacientes
}) => {
  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "fecha") {
      const date = new Date(value);
      date.setHours(0, 0, 0, 0);
      setAppointment(prev => ({ ...prev, [name]: formatDateForLocal(date) }));
    } else {
      setAppointment(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = () => {
    const validation = validateAppointment(appointment);
    if (!validation.isValid) {
      toast.error(validation.errors.join(', '));
      return;
    }
    onSave(appointment);
    onClose();
  };

  const sendWhatsAppMessage = () => {
    const validation = validateAppointment(appointment);
    if (!validation.isValid) {
      toast.error("Verifica que todos los campos estén completos antes de enviar el mensaje.");
      return;
    }

    const message = generateWhatsAppMessage(appointment);
    const telefonoLimpio = formatPhoneForWhatsApp(appointment.telefono);
    const whatsappUrl = `https://wa.me/${telefonoLimpio}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        {/* Encabezado del modal */}
        <div className="flex justify-between items-center border-b pb-4">
          <h2 className="text-lg font-semibold">Editar Cita</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        {/* Campo Paciente manual */}
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            Paciente
            <input
              type="text"
              name="paciente"
              value={appointment.paciente || ''}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2"
              placeholder="Nombre del paciente"
            />
          </label>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            Fecha
            <input
              type="date"
              name="fecha"
              value={appointment.fecha}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2"
            />
          </label>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            Hora
            <input
              type="time"
              name="hora"
              value={appointment.hora}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2"
            />
          </label>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            Motivo
            <input
              type="text"
              name="motivo"
              value={appointment.motivo}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2"
            />
          </label>
        </div>

        {/* Teléfono después de motivo y antes de estado */}
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            Teléfono
            <input
              type="tel"
              name="telefono"
              value={appointment.telefono || ''}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2"
              placeholder="Teléfono del paciente"
            />
          </label>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            Estado
            <select
              name="estado"
              value={appointment.estado}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2"
            >
              <option value="pendiente">Pendiente</option>
              <option value="confirmada">Confirmada</option>
              <option value="completada">Completada</option>
              <option value="cancelada">Cancelada</option>
              <option value="no_asiste">No Asiste</option>
            </select>
          </label>
        </div>

        {/* Botones */}
        <div className="flex justify-end mt-6 space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          >
            Guardar
          </button>
        </div>

        {/* Botón para enviar por WhatsApp */}
        <div className="flex justify-center mt-6">
          <button
            onClick={sendWhatsAppMessage}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Enviar Recordatorio por WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppointmentModal;
